<template>
   <div class="customer-container content-wrapper fluid">
      <CustomerBanner :config="customerPageData.content[0]" :customer-data="getCustomers" />

      <SuccessStoriesCustomer :config="customerPageData.content[1]" gradclass="grey-wrapper-2" />

      <div class="custom-container-1440">
         <HappyCustomer :config="happyCustomerConfig" />
      </div>

      <div class="row pt-5 pb-4 bottom-section ml-0 mr-0">
         <div class="col-12 text-center">
            <h3 class="">{{ customerFooter.header }}</h3>
            <div class="row">
               <div class="col-4" />
            </div>
            <div
               class="text-center subheading mb-5"
               v-html="markedRender(customerFooter.longDescription)"
            />

            <a
               :href="customerFooter.ctas[0].link"
               target="_blank"
               rel="noopener noreferrer"
               class="btn btn-primary-grad mb-1"
               >{{ customerFooter.ctas[0].header }}</a
            >

            <p class="text-center subheading mt-1">
               Install FusionCharts &amp; start charting today!
            </p>
         </div>
      </div>
   </div>
</template>

<script>
import { mapState } from 'vuex';
import CustomerBanner from '../../components/customer/CustomerBanner.vue';
import SuccessStoriesCustomer from '../../components/customer/SuccessStoriesCustomer.vue';
import metaGenerator from '../../util/meta.js';

import HappyCustomer from '../../components/pricing/HappyCustomer';

export default {
   name: 'CustomerView',
   components: {
      SuccessStoriesCustomer,
      CustomerBanner,
      HappyCustomer,
   },
   computed: {
      ...mapState(['customerPageData']),
      getExternalProperties() {
         return this.customerPageData && this.customerPageData.externalProperties;
      },
      getCustomers() {
         return this.getExternalProperties && this.getExternalProperties.customers;
      },
      happyCustomerConfig() {
         return {
            header: this.customerPageData.content[2].header,
            shortDescription: this.customerPageData.content[2].shortDescription,
         };
      },

      customerFooter() {
         return this.customerPageData.content[3];
      },
   },
   asyncData({ store }) {
      return Promise.all([store.dispatch('CUSTOMER_PAGE_DATA_FETCH')]);
   },
   metaInfo() {
      return metaGenerator(this.customerPageData);
   },
};
</script>

<style lang="scss" scoped>
.custom-container-1440 {
   max-width: 1200px;
   margin: 0 auto;
   padding: 0 30px;

   @media only screen and (max-width: 1024px) {
      max-width: 900px;
      margin: 0 auto;
   }

   @media only screen and (max-width: 991px) {
      max-width: 890px;
      margin: 0 auto;
   }

   @media only screen and (max-width: 799px) {
      padding: 0 36px;
   }
}

.bottom-section {
   background: linear-gradient(180deg, #f8fafc 0%, #f8fafc 100%);

   h3 {
      color: #2f3160;
      font-size: 30px;
      line-height: 38px;
   }
}
</style>
